import type { ClinicalImpression } from "@medplum/fhirtypes";
import { CLINICAL_NOTE_ENTITY_ID_SYSTEM } from "@repo/api";
import { asNoteId, type NoteId } from "@repo/domain";

/**
 * Stable ClinicalNote identity carried by its FHIR representation, or undefined
 * for a row that predates ADR-0020.
 *
 * Deliberately does NOT throw. This runs inside `deriveFields`, where a throw is
 * caught by `deriveForSync` and the whole row is silently dropped from the
 * collection — so a single pre-migration note would disappear from the UI with
 * only a console line to say why. Rows without identity are excluded from the
 * domain DTO stream instead, which is visible and intentional.
 */
export function clinicalNoteDomainId(note: ClinicalImpression): NoteId | undefined {
  const value = note.identifier?.find((identifier) => identifier.system === CLINICAL_NOTE_ENTITY_ID_SYSTEM)?.value;
  return value ? asNoteId(value) : undefined;
}
